<template>
	<section class="search-box">
		<div class="leftOuter">
			<div class="title">
				<div class="title-row">
					<div class="stitle">搜索结果</div>
				</div>
				<span class="stip"
					>共搜索到 <strong style="font-size: 18px; color: #2563eb">{{ searchTotal }}</strong> 条相关文件</span
				>
			</div>
			<!-- {{ searchParams }} -->
			<div class="searchtype">
				<!-- 文件类型 -->
				<div class="filter-section filter-grid-2">
					<h4 @click="toggleCollapse('fileType')" class="collapsible-header" :class="{ 'has-selected': hasFileTypeSelected }">
						<i :class="collapseStatus.fileType ? 'el-icon-caret-bottom' : 'el-icon-caret-right'" class="collapse-icon"></i>
						文件类型
					</h4>
					<el-checkbox-group v-show="collapseStatus.fileType" v-model="searchParams.standardType" @change="handleType">
						<el-checkbox v-for="(item, index) in typeList" :key="index" :label="item.id" class="mb5" :title="item.typeName">{{ item.typeName }} </el-checkbox>
					</el-checkbox-group>
				</div>

				<!-- 实施状态 -->
				<div class="filter-section filter-grid-2">
					<h4 @click="toggleCollapse('implementStatus')" class="collapsible-header" :class="{ 'has-selected': hasImplementStatusSelected }">
						<i :class="collapseStatus.implementStatus ? 'el-icon-caret-bottom' : 'el-icon-caret-right'" class="collapse-icon"></i>
						实施状态
					</h4>
					<el-checkbox-group v-show="collapseStatus.implementStatus" v-model="searchParams.lifeId" @change="handleStatus">
						<el-checkbox v-for="(item, index) in statusList" :key="index" :label="item.id" class="mb5" :title="item.lifeName">{{ item.lifeName }} </el-checkbox>
					</el-checkbox-group>
				</div>

				<!-- 设备类型 -->
				<div class="filter-section filter-grid-2">
					<h4 @click="toggleCollapse('deviceType')" class="collapsible-header" :class="{ 'has-selected': hasDeviceTypeSelected }">
						<i :class="collapseStatus.deviceType ? 'el-icon-caret-bottom' : 'el-icon-caret-right'" class="collapse-icon"></i>
						设备类型
					</h4>
					<div v-show="collapseStatus.deviceType" class="device-type-list">
						<el-checkbox v-for="item in categoryLabelList" :key="item.categoryId" :label="item.categoryId" class="mb5" :title="item.categoryName" v-model="searchParams.categoryId" @change="handleCategory">{{
							item.categoryName
						}}</el-checkbox>
					</div>
				</div>

				<!-- 是否可购买 -->
				<div class="filter-section">
					<h4 @click="toggleCollapse('productTypeId')" class="collapsible-header" :class="{ 'has-selected': hasIsBuySelected }">
						<i :class="collapseStatus.productTypeId ? 'el-icon-caret-bottom' : 'el-icon-caret-right'" class="collapse-icon"></i>
						"网上书城"能否购买
					</h4>
					<el-checkbox-group v-show="collapseStatus.productTypeId" v-model="searchParams.productTypeId" @change="handleStatusIsBuy">
						<el-checkbox v-for="(item, index) in isBuyList" :key="index" :label="item.value" class="mb5" :title="item.label">{{ item.label }} </el-checkbox>
					</el-checkbox-group>
				</div>

				<!-- PDF在线阅读 -->
				<div class="filter-section">
					<h4 @click="toggleCollapse('readTypeId')" class="collapsible-header" :class="{ 'has-selected': hasPdfReadSelected }">
						<i :class="collapseStatus.readTypeId ? 'el-icon-caret-bottom' : 'el-icon-caret-right'" class="collapse-icon"></i>
						<!-- PDF在线阅读 -->
						在线阅读
					</h4>
					<el-checkbox-group v-show="collapseStatus.readTypeId" v-model="searchParams.readTypeId" @change="handleStatusPdfRead">
						<el-checkbox v-for="(item, index) in pdfReadCollectList" :key="index" :label="item.value" class="mb5" :title="item.label">{{ item.label }} </el-checkbox>
					</el-checkbox-group>
				</div>

				<!-- AI知识库 -->
				<div class="filter-section">
					<h4 @click="toggleCollapse('aiHad')" class="collapsible-header" :class="{ 'has-selected': hasAiCollectSelected }">
						<i :class="collapseStatus.aiHad ? 'el-icon-caret-bottom' : 'el-icon-caret-right'" class="collapse-icon"></i>
						AI知识库
					</h4>
					<el-checkbox-group v-show="collapseStatus.aiHad" v-model="searchParams.aiHad" @change="handleStatusAI">
						<el-checkbox v-for="(item, index) in aiCollectList" :key="index" :label="item.value" class="mb5" :title="item.label">{{ item.label }} </el-checkbox>
					</el-checkbox-group>
				</div>
			</div>
			<div class="imgfooter">
				<img src="@/assets/images/booklist/searchleft.png" style="width: 140px" />
			</div>
		</div>
	</section>
</template>

<script>
	import { getStandardTypeOnlyStandard, getStandardType, getStandardCategory } from '@/api/standards/search';
	export default {
		props: {
			searchTotal: {
				type: Number,
				default: 0
			},
			statusList: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				typeList: [],
				allTypeList: [],
				simpleTypeList: [],
				searchParams: {
					lifeId: [],
					standardType: [],
					categoryId: [],
					readTypeId: [],
					aiHad: [],
					productTypeId: []
				},
				pdfReadCollectList: [
					{
						label: '公开文件',
						value: 0
					},
					{
						label: 'VIP阅读',
						value: 1
					},
					{
						label: '购买阅读',
						value: 2
					}
					// {
					// 	label: '在线阅读',
					// 	value: 0
					// },
					// {
					// 	label: '购买阅读',
					// 	value: 2
					// }
				],
				jsonReadCollectList: [
					{
						label: '智能文档',
						value: 1
					}
				],
				aiCollectList: [
					{
						label: 'AI收录',
						value: 1
					}
				],
				isBuyList: [
					{
						label: '纸质版可购',
						value: 0
					},
					{
						label: '电子版可购',
						value: 1
					}
				],
				// 设备类型列表
				categoryLabelList: [],
				// 折叠状态
				collapseStatus: {
					fileType: true, // 文件类型
					implementStatus: true, // 实施状态
					readTypeId: true, // PDF在线阅读
					aiHad: true, // AI收录
					productTypeId: true, // 是否可购买
					deviceType: true // 设备类型
				}
			};
		},
		computed: {
			// 判断各个筛选部分是否有选中项
			hasFileTypeSelected() {
				return this.searchParams.standardType.length > 0;
			},
			hasImplementStatusSelected() {
				return this.searchParams.lifeId.length > 0;
			},
			hasIsBuySelected() {
				return this.searchParams.productTypeId.length > 0;
			},
			hasPdfReadSelected() {
				return this.searchParams.readTypeId.length > 0;
			},
			hasAiCollectSelected() {
				return this.searchParams.aiHad.length > 0;
			},
			hasDeviceTypeSelected() {
				return this.searchParams.categoryId.length > 0;
			}
		},
		created() {
			this.getStandardType();
			this.getStandardTypeOnlyStandard();
			this.getStandardCategory();
		},

		methods: {
			// 切换折叠状态
			toggleCollapse(section) {
				this.collapseStatus[section] = !this.collapseStatus[section];
			},

			getTypeList(val) {
				if (val == 1) {
					this.typeList = this.allTypeList;
				} else {
					this.typeList = this.simpleTypeList;
				}
			},

			async getStandardType() {
				let res = await getStandardType();
				if (res.code == 200) {
					this.allTypeList = res.data;
					this.typeList = res.data;
				}
			},

			async getStandardTypeOnlyStandard() {
				let res = await getStandardTypeOnlyStandard();
				if (res.code == 200) {
					this.simpleTypeList = res.data;
				}
			},

			// 获取设备类型
			async getStandardCategory() {
				let res = await getStandardCategory();
				if (res.code == 200) {
					this.categoryLabelList = res.data;
				}
			},

			// 设备类型选中变化
			handleCategory() {
				this.$emit('categoryCheck', this.searchParams.categoryId);
			},

			handleType() {
				this.$emit('stanCheck', this.searchParams.standardType);
			},
			handleStatus() {
				this.$emit('statusCheck', this.searchParams.lifeId);
			},
			handleStatusIsBuy() {
				this.$emit('isBuyCheck', this.searchParams.productTypeId);
			},
			handleStatusPdfRead() {
				this.$emit('pdfReadCheck', this.searchParams.readTypeId);
			},
			handleStatusAI() {
				this.$emit('aiCheck', this.searchParams.aiHad);
			},
			
			// 清空所有选中值
			clearAllSelections() {
				this.searchParams.lifeId = [];
				this.searchParams.standardType = [];
				this.searchParams.readTypeId = [];
				this.searchParams.aiHad = [];
				this.searchParams.productTypeId = [];
				this.searchParams.categoryId = [];
			}
		},
		components: {}
	};
</script>

<style lang="less" scoped>
	// ========== 左侧筛选栏 - 1:1 匹配 lz_project store 侧边栏风格 ==========
	.leftOuter {
		// 卡片容器 - rounded-2xl shadow-sm border border-slate-100
		background-color: #ffffff;
		border-radius: 16px;
		border: 1px solid #f1f5f9;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.06);
		display: block;
		position: relative;
		overflow: hidden;

		// 搜索结果标题 - 匹配 lz_project 卡片内 header 风格
		.title {
			padding: 24px 24px 0 24px;
			margin-bottom: 0;

			.title-row {
				display: flex;
				align-items: center;
				justify-content: space-between;
			}

			.stitle {
				font-size: 16px;
				font-weight: 700;
				color: #0f172a;
				margin-bottom: 4px;
			}
			.show-product-check {
				flex-shrink: 0;
				margin-right: 0;
				padding: 5px 14px;
				background: #f8fafc;
				border: 1px solid #e2e8f0;
				border-radius: 20px;
				transition: all 0.25s ease;
			
				&:hover {
					border-color: #bfdbfe;
					background: #eff6ff;
					box-shadow: 0 2px 8px rgba(37, 99, 235, 0.1);
				}
			
				/deep/ .el-checkbox__label {
					font-size: 13px;
					font-weight: 600;
					color: #475569;
					transition: color 0.2s ease;
				}
			
				/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
					color: #2563eb;
				}
			
				&.is-checked {
					background: #eff6ff;
					border-color: #93c5fd;
					box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.08);
				}
			}
			.stip {
				font-size: 13px;
				font-weight: 400;
				color: #64748b;
				display: block;
				margin-top: 10px;
			}
		}

		.imgfooter {
			width: 140px;
			position: absolute;
			bottom: 0;
			right: 0;
			opacity: 0.5;
			pointer-events: none;
		}

		.searchtype {
			padding: 16px 16px 20px;
			display: flex;
			flex-direction: column;
			gap: 12px;

			// 卡片标题 - h4
			.collapsible-header {
				cursor: pointer;
				display: flex;
				align-items: center;
				margin: 0;
				padding: 0 4px 0 24px;
				font-size: 14px;
				font-weight: 700;
				color: #0f172a;
				transition: color 0.2s ease;
				position: relative;
				user-select: none;
				line-height: 1;

				&:hover {
					color: #2563eb;

					.collapse-icon {
						opacity: 1;
						visibility: visible;
						transform: translateY(-50%);
					}
				}

				// 有选中项 - blue accent
				&.has-selected {
					color: #2563eb;
					font-weight: 700;

					.collapse-icon {
						opacity: 1;
						visibility: visible;
						color: #2563eb;
					}
				}
			}

			// 折叠图标
			.collapse-icon {
				transition: all 0.3s ease;
				font-size: 12px;
				position: absolute;
				left: 4px;
				top: 50%;
				transform: translateY(-50%);
				opacity: 0;
				visibility: hidden;
				font-weight: bold;
			}

			// 每张筛选卡片
			.filter-section {
				background: #f8fafc;
				border-radius: 12px;
				border: 1px solid #f1f5f9;
				padding: 14px 16px;
				transition: box-shadow 0.2s ease, border-color 0.2s ease;

				&:hover {
					border-color: #e2e8f0;
					box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
				}

				// 展开状态下 有选中项高亮卡片
				&:has(.has-selected) {
					border-color: #bfdbfe;
					background: #eff6ff;
				}

				// 卡片内容区
				.el-checkbox-group,
				.device-type-list {
					margin-top: 12px;
					padding-top: 10px;
					border-top: 1px solid #e8edf3;
				}

				.device-type-list {
					display: flex;
					flex-wrap: wrap;
				}

				// 两列网格布局
				&.filter-grid-2 {
					.el-checkbox-group,
					.device-type-list {
						display: grid;
						grid-template-columns: 1fr 1fr;
						gap: 4px 12px;

						.el-checkbox {
							margin-right: 0;
							min-width: 0;
							overflow: hidden;
						}
					}
				}
			}
		}

		.mb5 {
			margin-bottom: 6px;
		}

		// 复选框 - 匹配 lz_project hover:bg-slate-50 rounded-lg
		.el-checkbox {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			padding: 5px 8px;
			border-radius: 8px;
			transition: background 0.15s ease;

			&:hover {
				background-color: #f8fafc;
			}
		}
	}

	// ========== 响应式：小屏回退单列 ==========
	@media screen and (max-width: 1366px) {
		.leftOuter .title {
			padding: 16px 16px 0 16px;

			.title-row {
				flex-direction: column;
				align-items: flex-start;
				gap: 10px;
			}

			.show-product-check {
				order: -1;
				align-self: flex-start;
			}

			.stitle {
				order: 0;
			}
		}

		.leftOuter .searchtype .filter-section.filter-grid-2 {
			.el-checkbox-group,
			.device-type-list {
				grid-template-columns: 1fr;
				gap: 4px 0;
			}
		}
	}

	@media screen and (min-width: 1366px) and (max-width: 3000px) {
		.leftOuter .searchtype .filter-section.filter-grid-2 {
			.el-checkbox-group,
			.device-type-list {
				grid-template-columns: 1fr;
				gap: 4px 0;
			}
		}
	}

	// 复选框标签文字 - text-sm text-slate-600
	/deep/ .el-checkbox__label {
		font-size: 13px;
		color: #475569;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		line-height: 1.4;
	}

	// 复选框输入框垂直居中
	/deep/ .el-checkbox__input {
		display: inline-flex;
		align-items: center;
		height: auto;
	}

	/deep/ .el-checkbox__inner {
		position: static;
	}

	// 复选框选中态 - 匹配 lz_project text-blue-700 font-medium
	/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
		color: #2563eb;
	}
</style>
